import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-18234b72"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "mb-4 px-3 text-sm inline-flex py-2 text-primary bg-primary/5 rounded-md font-medium"
};
var _hoisted_2 = {
    key: 1,
    class: "mb-4 px-3 text-sm inline-flex py-2 bg-gray-100 rounded-md font-medium"
};
var _hoisted_3 = {
    key: 3,
    class: "mb-2.5 line-through text-gray-400"
};
var _hoisted_4 = {
    key: 4,
    class: "mb-2.5 line-through text-gray-400"
};
var _hoisted_5 = { class: "flex items-center" };
var _hoisted_6 = {
    key: 0,
    class: "text-2xl font-medium"
};
var _hoisted_7 = {
    key: 1,
    class: "text-2xl font-medium"
};
var _hoisted_8 = {
    key: 2,
    class: "payment-option__discount"
};
var _hoisted_9 = { class: "relative" };
var _hoisted_10 = {
    key: 5,
    class: "mt-4 text-gray-400"
};
var _hoisted_11 = {
    key: 6,
    class: "mt-3 text-gray-400"
};
var _hoisted_12 = {
    key: 0,
    class: "w-4 h-4 bg-primary rounded-full"
};
import { computed } from 'vue';
import { getCurrencyByCode } from '@common/utils/Currencies/Currencies';
import { formatPrice } from '@common/utils/Format/Format';
import EHelp from '@common/ui/EHelp.vue';
import { isIOSApp } from '@common/utils/MobileApp';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentOption',
    props: {
        type: {},
        selected: { type: Boolean },
        currency: {},
        price: {},
        priceOld: {},
        hideRadio: { type: Boolean },
        showHelpers: { type: Boolean },
        promocode: {}
    },
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var currencySymbol = computed(function () {
            var _a;
            return (_a = getCurrencyByCode(props.currency)) === null || _a === void 0 ? void 0 : _a.symbol;
        });
        var discountPercent = computed(function () {
            var _a;
            if (!props.priceOld && !props.promocode) {
                return;
            }
            var priceOld = (_a = props.priceOld) !== null && _a !== void 0 ? _a : props.price;
            return Math.floor(((priceOld - computedPrice.value) / priceOld) * 100);
        });
        var computedPriceOld = computed(function () {
            var priceOld = props.priceOld;
            if (!priceOld) {
                return;
            }
            return priceOld;
        });
        var computedPrice = computed(function () {
            var _a, _b;
            var price = props.price;
            if (((_a = props.promocode) === null || _a === void 0 ? void 0 : _a.discountType) === 'fixed') {
                price = Math.max(0, price - props.promocode.discount);
            }
            else if (((_b = props.promocode) === null || _b === void 0 ? void 0 : _b.discountType) === 'percent') {
                price = price - (price / 100 * props.promocode.discount);
            }
            return price;
        });
        var convertToInstallmentPrice = function (price) {
            return Math.floor(price / 36);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        _ctx.selected ? 'border-primary' : 'border-white cursor-pointer hover:border-gray-200'
                    ], "payment-option"])
            }, [
                _createElementVNode("div", null, [
                    (_ctx.type === 'installment')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)('payment.installment')), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('payment.full')), 1)),
                    (_ctx.showHelpers && _ctx.type === 'installment')
                        ? (_openBlock(), _createBlock(EHelp, {
                            key: 2,
                            class: "ml-2 relative top-0.5",
                            text: _unref(t)('payment.helperText')
                        }, null, 8, ["text"]))
                        : _createCommentVNode("", true),
                    (_ctx.priceOld && _ctx.type === 'installment')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('payment.from')) + " " + _toDisplayString(_unref(formatPrice)(convertToInstallmentPrice(computedPriceOld.value))) + " " + _toDisplayString(currencySymbol.value) + "/" + _toDisplayString(_unref(t)('payment.month')), 1))
                        : (_ctx.priceOld)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(formatPrice)(computedPriceOld.value)) + " " + _toDisplayString(currencySymbol.value), 1))
                            : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        (_ctx.type === 'installment')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('payment.from')) + " " + _toDisplayString(_unref(formatPrice)(convertToInstallmentPrice(computedPrice.value))) + " " + _toDisplayString(currencySymbol.value) + "/" + _toDisplayString(_unref(t)('payment.month')), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(formatPrice)(computedPrice.value)) + " " + _toDisplayString(currencySymbol.value), 1)),
                        (discountPercent.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("p", _hoisted_9, " – " + _toDisplayString(discountPercent.value) + "% ", 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.type === 'installment')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)('payment.noOverpayment')), 1))
                        : _createCommentVNode("", true),
                    (!_unref(isIOSApp)())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.type === 'installment' ? _unref(t)('payment.firstPayment') : _unref(t)('payment.securePayment')), 1))
                        : _createCommentVNode("", true)
                ]),
                (!_ctx.hideRadio)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([[
                                _ctx.selected ? 'border-primary' : 'border-gray-300'
                            ], "shrink-0 w-7 h-7 rounded-full border flex items-center justify-center ml-4"])
                    }, [
                        (_ctx.selected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
